export default {
	methods: {
		onButtonClicked(e) {
			this.$emit("button-click", e);
		}
	}
};
